import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var FavoriteService = /** @class */ (function () {
    function FavoriteService(http) {
        this.http = http;
        this.checkMonth = [
            {
                number: 1,
                name: 'มกราคม'
            },
            {
                number: 2,
                name: 'กุมภาพันธ์'
            },
            {
                number: 3,
                name: 'มีนาคม'
            },
            {
                number: 4,
                name: 'เมษายน'
            },
            {
                number: 5,
                name: 'พฤษภาคม'
            },
            {
                number: 6,
                name: 'มิถุนายน'
            },
            {
                number: 7,
                name: 'กรกฎาคม'
            },
            {
                number: 8,
                name: 'สิงหาคม'
            },
            {
                number: 9,
                name: 'กันยายน'
            },
            {
                number: 10,
                name: 'ตุลาคม'
            },
            {
                number: 11,
                name: 'พฤศจิกายน'
            },
            {
                number: 12,
                name: 'ธันวาคม'
            }
        ];
    }
    FavoriteService.prototype.changeFormatDate = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month; })[0];
        return day + ' ' + monthTh['name'] + ' ' + year;
    };
    FavoriteService.prototype.Post_get_fund_ByFAV = function (ip, fundtype) {
        var URL = cmsApi + '/Post_get_fund_ByFAV';
        var body = {
            IP: ip,
            FundType: fundtype
        };
        // console.log(body);
        return this.http.post(URL, body);
    };
    FavoriteService.ngInjectableDef = i0.defineInjectable({ factory: function FavoriteService_Factory() { return new FavoriteService(i0.inject(i1.HttpClient)); }, token: FavoriteService, providedIn: "root" });
    return FavoriteService;
}());
export { FavoriteService };
